const OrigemAplicacaoInventarioHierarquiaEnum = {
    CHECKLIST: 'CHECKLIST',
    INVENTARIO: 'INVENTARIO',
    CHECKLIST_INVENTARIO: 'CHECKLIST_INVENTARIO',
    RASCUNHO: 'RASCUNHO'
}

export default OrigemAplicacaoInventarioHierarquiaEnum;
